module.exports = __webpack_public_path__ + "img/loading.3da76622.gif";